import { Action, Reducer } from "redux";
import { CountryState, CountryTypes, CountryActionTypes } from "./countryTypes";

export const INITIAL_STATE: CountryState = {
	countriesUser: {
		data: null,
		errorMessages: null,
		isError: false,
		isLoading: false,
	},
	countriesPublic: {
		data: null,
		errorMessages: null,
		isError: false,
		isLoading: false,
	},
};

const countryReducer: Reducer<CountryState> = (state: CountryState = INITIAL_STATE, action: Action) => {
	const actionTypes = action as CountryActionTypes;
	switch (actionTypes.type) {
		case CountryTypes.GET_COUNTRIES_USER:
			return {
				...state,
				countriesUser: { ...state.countriesUser, isLoading: true },
			};
		case CountryTypes.GET_COUNTRIES_PUBLIC:
			return {
				...state,
				countriesPublic: { ...state.countriesPublic, isLoading: true },
			};
		case CountryTypes.SAVE_COUNTRIES_USER:
			return {
				...state,
				countriesUser: {
					...state.countriesUser,
					isLoading: false,
					errorMessages: actionTypes.payload.errorMessages,
					isError: actionTypes.payload.isError,
					data: actionTypes.payload.data,
				},
			};
		case CountryTypes.SAVE_COUNTRIES_PUBLIC:
			return {
				...state,
				countriesPublic: {
					...state.countriesPublic,
					isLoading: false,
					errorMessages: actionTypes.payload.errorMessages,
					isError: actionTypes.payload.isError,
					data: actionTypes.payload.data,
				},
			};
		case CountryTypes.RESET_REDUCER_COUNTRIES_USER:
			return {
				...state,
				countriesUser: INITIAL_STATE.countriesUser,
			};
		default:
			return state;
	}
};

export default countryReducer;
